import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class LazyVideo extends Component {
  connectedCallback() {
    super.connectedCallback();

    const template = this.querySelector('template');
    if (!template) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.appendChild(template.content.cloneNode(true));
            template.remove();

            const poster = this.querySelector('picture');
            const video = this.querySelector('video');

            if (video && video.hasAttribute('muted')) {
              video.muted = true;
              video.defaultMuted = true;
            }

            if (video && prefersReducedMotion()) {
              video.removeAttribute('autoplay');
              video.pause();
            } else if (video && video.hasAttribute('autoplay')) {
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            }

            if (poster && video) {
              video.addEventListener('playing', () => poster.remove(), { once: true });
            } else if (poster) {
              poster.remove();
            }

            observer.disconnect();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    observer.observe(this);
  }
}

customElements.define('lazy-video', LazyVideo);
